import React from 'react';
import DetailListItem from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { advisorPage } from 'Consts/Strings';

const styles = () => ({
  familyMember: {},
});


function InvestmentProfileFamilyMemberList({
  familyMembers,
  classes,
}) {
  return familyMembers.map((familyMember) => (
    <DetailListItem
      key={familyMember.id()}
      onClick={() => {
        const href = `${advisorPage}?pageSelfLink=${encodeURIComponent(familyMember.relationship(fr.relationships.subStep.name).link('related').url())}`;
        window.open(href, '_blank');
      }}
      className={classes.familyMember}
      resource={familyMember}
    />
  ));
}
InvestmentProfileFamilyMemberList.propTypes = {
  classes: PropTypes.object.isRequired,
  familyMembers: PropTypes.object.isRequired,
};

InvestmentProfileFamilyMemberList.defaultProps = {
};

export default withStyles(styles)(InvestmentProfileFamilyMemberList);
